/* Local dependencies */
import { User } from '../../types';
import {
  ListUsers,
  ListUsersActionTypes,
  ListUsersError,
  ListUsersInput,
  ListUsersSuccess,
  ResetListUsersError,
  ResetListUsersState,
} from './types';

export function listUsers(input: ListUsersInput): ListUsers {
  return {
    type: ListUsersActionTypes.LIST_USERS_REQUEST,
    input,
  };
}

export function listUsersSuccess(total: number, users: User[]): ListUsersSuccess {
  return {
    type: ListUsersActionTypes.LIST_USERS_SUCCESS,
    users,
    total,
  };
}

export function listUsersError(error: Error): ListUsersError {
  return {
    type: ListUsersActionTypes.LIST_USERS_ERROR,
    error,
  };
}

export function resetListUsersError(): ResetListUsersError {
  return {
    type: ListUsersActionTypes.RESET_ERROR,
  };
}

export function resetListUsersState(): ResetListUsersState {
  return {
    type: ListUsersActionTypes.RESET_STATE,
  };
}
